import { CardEnum, TileCornerBuildingType, TileHexType } from '@colonist/game-states';
export class ProductionController {
    getProductionForCornerPieceAndTile(cornerBuilding, tileType) {
        switch(cornerBuilding){
            case TileCornerBuildingType.KnightActiveLevel1:
            case TileCornerBuildingType.KnightActiveLevel2:
            case TileCornerBuildingType.KnightActiveLevel3:
            case TileCornerBuildingType.KnightInactiveLevel1:
            case TileCornerBuildingType.KnightInactiveLevel2:
            case TileCornerBuildingType.KnightInactiveLevel3:
                return [];
            case TileCornerBuildingType.DestroyedCity:
            case TileCornerBuildingType.Settlement:
                return this.getProductionForSettlement(tileType);
            case TileCornerBuildingType.City:
                return this.getProductionForCity(tileType);
        }
    }
    getProductionForSettlement(tileType) {
        switch(tileType){
            case TileHexType.Lumber:
                return this.settlementLumberProduction;
            case TileHexType.Brick:
                return this.settlementBrickProduction;
            case TileHexType.Wool:
                return this.settlementWoolProduction;
            case TileHexType.Grain:
                return this.settlementGrainProduction;
            case TileHexType.Ore:
                return this.settlementOreProduction;
            case TileHexType.Gold:
                return this.settlementGoldProduction;
            case TileHexType.Sea:
                return this.settlementSeaProduction;
            case TileHexType.Desert:
                return this.settlementDesertProduction;
            case TileHexType.Fog:
                return this.settlementFogProduction;
        }
    }
    getProductionForCity(tileType) {
        switch(tileType){
            case TileHexType.Lumber:
                return this.cityLumberProduction;
            case TileHexType.Brick:
                return this.cityBrickProduction;
            case TileHexType.Wool:
                return this.cityWoolProduction;
            case TileHexType.Grain:
                return this.cityGrainProduction;
            case TileHexType.Ore:
                return this.cityOreProduction;
            case TileHexType.Gold:
                return this.cityGoldProduction;
            case TileHexType.Sea:
                return this.citySeaProduction;
            case TileHexType.Desert:
                return this.cityDesertProduction;
            case TileHexType.Fog:
                return this.cityFogProduction;
        }
    }
}
export class ClassicResourceProductionController extends ProductionController {
    constructor(...args){
        super(...args), this.settlementLumberProduction = [
            CardEnum.Lumber
        ], this.settlementBrickProduction = [
            CardEnum.Brick
        ], this.settlementWoolProduction = [
            CardEnum.Wool
        ], this.settlementGrainProduction = [
            CardEnum.Grain
        ], this.settlementOreProduction = [
            CardEnum.Ore
        ], this.settlementGoldProduction = [], this.settlementSeaProduction = [], this.settlementDesertProduction = [], this.settlementFogProduction = [], this.cityLumberProduction = [
            CardEnum.Lumber,
            CardEnum.Lumber
        ], this.cityBrickProduction = [
            CardEnum.Brick,
            CardEnum.Brick
        ], this.cityWoolProduction = [
            CardEnum.Wool,
            CardEnum.Wool
        ], this.cityGrainProduction = [
            CardEnum.Grain,
            CardEnum.Grain
        ], this.cityOreProduction = [
            CardEnum.Ore,
            CardEnum.Ore
        ], this.cityGoldProduction = [], this.citySeaProduction = [], this.cityDesertProduction = [], this.cityFogProduction = [];
    }
}
export class CommodityResourceProductionController extends ProductionController {
    constructor(...args){
        super(...args), this.settlementLumberProduction = [
            CardEnum.Lumber
        ], this.settlementBrickProduction = [
            CardEnum.Brick
        ], this.settlementWoolProduction = [
            CardEnum.Wool
        ], this.settlementGrainProduction = [
            CardEnum.Grain
        ], this.settlementOreProduction = [
            CardEnum.Ore
        ], this.settlementGoldProduction = [], this.settlementSeaProduction = [], this.settlementDesertProduction = [], this.settlementFogProduction = [], this.cityLumberProduction = [
            CardEnum.Lumber,
            CardEnum.Paper
        ], this.cityBrickProduction = [
            CardEnum.Brick,
            CardEnum.Brick
        ], this.cityWoolProduction = [
            CardEnum.Wool,
            CardEnum.Cloth
        ], this.cityGrainProduction = [
            CardEnum.Grain,
            CardEnum.Grain
        ], this.cityOreProduction = [
            CardEnum.Ore,
            CardEnum.Coin
        ], this.cityGoldProduction = [], this.citySeaProduction = [], this.cityDesertProduction = [], this.cityFogProduction = [];
    }
}
